import { COLOR_GRAY_5 } from "./ImsMaterialTheme";

interface GrayDotProps extends React.HTMLAttributes<HTMLDivElement> {}

const GrayDot = ({ style, ...rest }: GrayDotProps) => {
  return (
    <div
      {...rest}
      style={{
        backgroundColor: COLOR_GRAY_5,
        borderRadius: "50%",
        width: "16px",
        height: "16px",
        display: "inline-block",
        ...style, // Merge custom styles with default styles
      }}
    />
  );
};

export { GrayDot };